export default "__VITE_ASSET__CEndUILY__"